var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"20","cy":"20","r":"19.5","stroke":"#EEEEEE","strokeOpacity":"0.5","key":0}),React.createElement("path",{"d":"M12.9894 14H27.0106C28.3333 14 29 14.6392 29 15.9392V25.0608C29 26.35 28.3333 27 27.0106 27H12.9894C11.6667 27 11 26.35 11 25.0608V15.9392C11 14.6392 11.6667 14 12.9894 14ZM19.9947 23.3167L27.127 17.3258C27.381 17.1092 27.582 16.6108 27.2646 16.1667C26.9577 15.7225 26.3968 15.7117 26.0265 15.9825L19.9947 20.1642L13.9735 15.9825C13.6032 15.7117 13.0423 15.7225 12.7354 16.1667C12.418 16.6108 12.619 17.1092 12.873 17.3258L19.9947 23.3167Z","fill":"#EEEEEE","key":1})]);
}

Email.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Email;

Email.default = Email;
